<template>
    <div class="outer-box" >
      <h4>Get Entity Details for Domain</h4>

      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Domain Name"
          v-model="domainName"
        />
        <button class="btn btn-primary mt-4" @click="fetchLocationAgencyForDomain">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Fetch Entity Data </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>

<script>
import { EmailISVService } from '@/services';

export default {
  data() {
    return {
      domainName: '',
      processing: false,
      response: null
    };
  },
  methods: {
    async fetchData(target, active, entityType) {
        try {
            const response = await EmailISVService.searchDomain(target, this.domainName, active);
            if(response && response.data) {
                return {
                    id: response.data.id,
                    name: response.data.name,
                    type: entityType,
                    deleted: response.data.deleted
                }
            }
            else return null
        }
        catch(error) {
            return null;
        }
    },
    async fetchLocationAgencyForDomain(){
        try {
            this.processing = true;

            const response = await Promise.all([
                this.fetchData('COMPANY', true , 'Agency'),
                this.fetchData('COMPANY', false, 'Agency'),
                this.fetchData('LOCATION', true, 'Sub-Account'),
                this.fetchData('LOCATION', false, 'Sub-Account')
            ])

            const responseData = response.reduce((result, data) => data ? data : result, null);
            if(responseData) {
                this.response = responseData
            }
            else {
                this.response = {
                    message: "Domain is not being used by any Agency or Sub-account."
                }
            }
        }
        catch (error) {
            this.response = {
                message: error.message || "Some error Occured. Please try again."
            }
        }
        finally {
            this.processing = false;
        }
    },
  }
}
</script>
